/**
 * Hide OOS variant cards on lander-style collections
 *
 * Each .lander-card on a Coldest collection represents a SPECIFIC variant
 * (e.g. "PURSUIT OF WINNING — 46oz"), not a parent product. So when a
 * variant runs out of stock, its card stays visible unless we hide it.
 *
 * This script:
 *   1. Reads every .lander-card on the page and collects their data-vid.
 *   2. Fetches /collections/<handle>/products.json (one request, cached
 *      via the existing /cart.js cache pattern) to build a
 *      variant_id → available map.
 *   3. Hides any card whose variant is available=false.
 *
 * Runs on the limitless-bottle-with-handle collection by default. Extend
 * the COLLECTION_HANDLES list to add more.
 *
 * Performance: single network request shared across all cards. Re-runs
 * on mutation if Boost re-renders the grid.
 */
(function () {
  'use strict';

  // Collections this script should run on. To enable on more
  // collections, just add their handle here.
  var COLLECTION_HANDLES = [
    'limitless-bottle-with-handle',
    // 'limitless-water-bottles',  // example for future expansion
  ];

  // Detect the current collection from the URL
  function currentCollectionHandle() {
    var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  var handle = currentCollectionHandle();
  if (!handle || COLLECTION_HANDLES.indexOf(handle) === -1) return;

  var availabilityMap = null;
  var fetchPromise = null;

  function fetchAvailability() {
    if (fetchPromise) return fetchPromise;
    fetchPromise = fetch('/collections/' + handle + '/products.json?limit=50', {
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var map = Object.create(null);
        (data.products || []).forEach(function (p) {
          (p.variants || []).forEach(function (v) {
            map[String(v.id)] = v.available !== false;
          });
        });
        availabilityMap = map;
        return map;
      })
      .catch(function () {
        availabilityMap = {};
        return {};
      });
    return fetchPromise;
  }

  function hideOOSCards() {
    if (!availabilityMap) return;
    var cards = document.querySelectorAll('.lander-card[data-vid]');
    var hidden = 0;
    cards.forEach(function (card) {
      var vid = card.getAttribute('data-vid');
      if (!vid) return;
      // Only hide if we have authoritative data and it says unavailable
      if (vid in availabilityMap && availabilityMap[vid] === false) {
        // Hide both the card and any wrapping grid cell so the layout
        // closes up rather than leaving a gap.
        card.style.display = 'none';
        var parent = card.parentElement;
        if (parent && parent.classList && (
          parent.classList.contains('grid__item') ||
          parent.classList.contains('product-grid-item') ||
          parent.classList.contains('lander-card-wrap')
        )) {
          parent.style.display = 'none';
        }
        card.setAttribute('data-cldst-hidden-oos', '1');
        hidden++;
      }
    });
    if (hidden > 0 && window.console && console.info) {
      console.info('[coldest-hide-oos-cards] Hidden ' + hidden + ' out-of-stock card(s) on /collections/' + handle);
    }
  }

  function init() {
    fetchAvailability().then(hideOOSCards);

    // Re-run when Boost / lazy-render adds more cards
    if ('MutationObserver' in window) {
      var grid = document.querySelector('.collection-grid, .product-list, [data-collection-grid], main') || document.body;
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length > 0) {
            // Debounce: schedule a single re-run
            clearTimeout(observer._t);
            observer._t = setTimeout(hideOOSCards, 250);
            break;
          }
        }
      });
      observer.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
